import React from "react";
import "./Contact.css";

function Contact() {

  return (
<>
    <section className="contact-section">

      {/* Left Side */}

      <div className="contact-left">

        <span>Contact Us</span>

        <h1>
          Get Fast Washing <br />
          Machine Service <br />
          In Chennai
        </h1>

        <p>
          Contact Chennai Washcare for professional doorstep washing
          machine repair and maintenance services across Chennai.
        </p>

        {/* Contact Info */}

        <div className="contact-info">

          <div className="contact-card">

            <h2>Phone Number</h2>

            <a href="tel:+919790066906">
             +91 9790066906
            </a>

          </div>

          <div className="contact-card">

            <h2>Email Address</h2>

            <a href="mailto:chennaiwashcare210@gmail.com">
              chennaiwashcare210@gmail.com
            </a>

          </div>

          <div className="contact-card">

            <h2>Location</h2>

            <p>
              Saidapet, Chennai, Tamil Nadu - 600015
            </p>

          </div>

        </div>

      </div>

      {/* Right Side */}

      <div className="contact-right">

        <form className="contact-form">

          <input
            type="text"
            placeholder="Your Name"
          />

          <input
            type="tel"
            placeholder="Phone Number"
          />

          <input
            type="email"
            placeholder="Email Address"
          />

          <textarea
            rows="5"
            placeholder="Your Message"
          ></textarea>

          <button type="submit">
            Book Service
          </button>

        </form>

      </div>

    </section>

<section className="contact-info-section">

  {/* Heading */}

  <div className="contact-info-heading">

    <span>Contact Details</span>

    <h1>
      Get In Touch <br />
      With Chennai Washcare
    </h1>

  </div>

  {/* Contact Cards */}

  <div className="contact-info-container">

    {/* Phone */}

    <div className="contact-info-card">

      <div className="contact-icon">
        📞
      </div>

      <h2>Call Us</h2>

      <a href="tel:+919790066906">
       +91 9790066906
      </a>

    </div>

    {/* Email */}

    <div className="contact-info-card">

      <div className="contact-icon">
        ✉️
      </div>

      <h2>Email Address</h2>

      <a href="mailto:chennaiwashcare210@gmail.com">
        chennaiwashcare210@gmail.com
      </a>

    </div>

    {/* Address */}

    <div className="contact-info-card">

      <div className="contact-icon">
        📍
      </div>

      <h2>Office Address</h2>

      <p>
        Saidapet, Chennai,
        Tamil Nadu - 600015
      </p>

    </div>

  </div>

</section>


<section className="map-section">

  {/* Heading */}

  <div className="map-heading">

    <span>Our Location</span>

    <h1>
      Visit Chennai <br />
      Washcare Service Center
    </h1>

  </div>

  {/* Google Map */}

  <div className="map-container">

    <iframe
      src="https://www.google.com/maps?q=Saidapet,Chennai,TamilNadu&output=embed"
      title="Chennai Washcare Location"
      allowFullScreen=""
      loading="lazy"
    ></iframe>

  </div>

</section>

    
    </>


  );

}

export default Contact;